import styled from "styled-components";
import { HorizontalMain } from "../../style/default";

export const MyHorizontalScrollView = styled(HorizontalMain)`
	justify-content: space-between;
	padding: 1rem;
	> div {
		display: flex;
		align-items: center;

		button {
			background-color: "transparent";
			color: "#000";
			border: 1px solid #fff;
			font-size: 15px;
			display: flex;
			align-items: center;
			border-radius: 4px;
			min-height: 36px;
			padding: 5px;
			&:focus {
				border: 1px solid #ddd;
			}
		}

		> input {
			min-height: 38px;
			padding: 2px 8px;
			border-color: hsl(0, 0%, 80%) !important;
			margin-left: 1rem;
			-moz-appearance: textfield;
			&::-webkit-inner-spin-button,
			&::-webkit-outer-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
			&:focus {
				box-shadow: none;
				border-color: #2684ff !important;
			}
		}
		> div {
			width: 100%;
		}
		> div:not(:first-child) {
			margin-left: 1rem;
		}
	}

	> div:last-child {
		width: 100%;

		> div {
			width: 300px;
			padding: 0.35rem;
		}
	}
`;
